import { render, staticRenderFns } from "./ModalDepartment.vue?vue&type=template&id=391f154a&scoped=true&lang=pug&"
import script from "./ModalDepartment.vue?vue&type=script&lang=js&"
export * from "./ModalDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ModalDepartment.vue?vue&type=style&index=0&id=391f154a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f154a",
  null
  
)

export default component.exports